import styled from 'styled-components';
import { Row } from 'components/grid';

const StyledTab = styled.button`
  height: 48px;
  padding: 2px 32px;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active, theme }) => (active ? theme.colors.mainColor : 'transparent')};

  ${({ theme }) => theme.typograph.paragraphRegular};
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.gray400};
  }
`;

const TabsContainer = styled.div`
  height: 48px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray300};
  margin-bottom: 48px;
`;

const Container = styled(Row)`
  height: 100%;
`;

export {
  Container,
  StyledTab,
  TabsContainer,
};
